import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const segmentsApi = new ApiCrud(http.AXIOS, {
  download: 'GET /segments/download',
});
export default segmentsApi;
